export default __webpack_public_path__ + "media/zurb/img/events/soapbox/soapbox-img3-e30a30253172eefa126557d76e48f80f.png";